import { instance } from './instance';

export const extraOptionService = {
  async getExtraGroups() {
    const response = await instance.get('/Extras');
    return response.data;
  },

  async getAllOptions() {
    const response = await instance.get('/ExtraOptions');
    return response.data;
  },

  async getGroupOptions(groupId) {
    const response = await instance.get(`/Extras/GroupOptions/${groupId}`);
    return response.data;
  },

  async createGroup(data) {
    const response = await instance.post('/Extras', data);
    return response.data;
  },

  async updateGroup(id, data) {
    const response = await instance.put(`/Extras/${id}`, data);
    return response.data;
  },

  async deleteGroup(id) {
    return instance.delete(`/Extras/${id}`);
  },

  async createOption(data) {
    const response = await instance.post('/Extras/options', data);
    return response.data;
  },

  async updateOption(id, data) {
    const response = await instance.put(`/Extras/options/${id}`, data);
    return response.data;
  },

  async deleteOption(id) {
    return instance.delete(`/Extras/options/${id}`);
  }
};
